<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getPollTemplate } from '@/services/pollTemplateService.js'

import ButtonSalva from '@/components/Generics/Buttons/ButtonSalva.vue'
import ButtonTornaAllaLista from '@/components/Generics/Buttons/ButtonTornaAllaLista.vue'

import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)

const props = defineProps(['updatePageTitle'])
const router = useRouter()
const route = useRoute()

const canView = ref(false)
const loading = ref(true)
const poll = ref(null)
const newPollTitle = defineModel('newPollTitle')
const newPollDescription = defineModel('newPollDescription')

onMounted(async () => {

  if (route.meta?.permissions) {
    canView.value = route.meta.permissions.canView ?? false
  }

  if (!canView.value) {
    return
  }

  poll.value = await getPollTemplate(route.params.id)
  props.updatePageTitle('Modifica template - ' + poll.value.title)
  newPollTitle.value = poll.value.title ?? ''
  newPollDescription.value = poll.value.description ?? ''
  loading.value = false
})

async function editPoll() {
  loading.value = true

  let title = newPollTitle.value
  let description = newPollDescription.value

  try {
    let url = `/config/templates/polls/api/poll-template/${poll.value.id}`
    await client.put(url, {
      title: title,
      description: description,
      tags: poll.value.tags,
      state: poll.value.state
    })
    toast.create('Template modificato con successo', 'success')
    loading.value = false
  } catch (error) {
    loading.value = false
    toast.create('Errore nell\'invio della richiesta, riprova', 'error')
  }
}

</script>

<template>
  <div class="mt-2 p-2 card shadow-none">
    <div class="mb-3">
      <label for="pollTitle" class="form-label">Titolo *</label>
      <input
        v-model="newPollTitle"
        name="pollTitle"
        type="text"
        required
        class="form-control"
        id="pollTitle"
        placeholder="Titolo template"
      />
    </div>
    <div class="mb-3">
      <label for="pollDescription" class="form-label">Descrizione *</label>
      <textarea
        v-model="newPollDescription"
        name="pollDescription"
        class="form-control"
        required
        id="pollDescription"
      ></textarea>
    </div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <button-torna-alla-lista @click="router.back()"></button-torna-alla-lista>
    <button-salva :loading="loading" :disabled="loading || !newPollTitle || !newPollDescription"
                  @click="editPoll">
    </button-salva>
  </div>

</template>

<style>
</style>
